import { render } from "./DefectPage.vue?vue&type=template&id=fb05db7e"
import script from "./DefectPage.vue?vue&type=script&lang=js"
export * from "./DefectPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__